import { OfferSyncModel } from './../models/synchronization/offerSyncModel';
import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';

class SynchronizationService {
    authService = new AuthService();
    axiosInstance = axios.create({
        baseURL: `${Constants.apiUrl}/`,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    })

    getData(lastSyncDate) {
        if (lastSyncDate === null) lastSyncDate = '';
        return this.axiosInstance({
            url: `synchronization/getData/${lastSyncDate}`,
            method: 'get',
            baseURL: `${Constants.apiUrl}/`
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    reportOffers(offers: Array<OfferSyncModel>) {
        return this.axiosInstance({
            url: `synchronization/reportOffers`,
            method: 'post',
            baseURL: `${Constants.apiUrl}/`,
            data: JSON.stringify(offers),
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${this.authService.getToken()}`,
                Pragma: 'no-cache'
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    reportOffer(offer: OfferSyncModel) {
        return this.axiosInstance({
            url: `synchronization/reportOffer`,
            method: 'post',
            baseURL: `${Constants.apiUrl}/`,
            data: JSON.stringify(offer)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteOffers(offers: Array<number>) {
        return this.axiosInstance({
            url: `synchronization/deleteOffers`,
            method: 'post',
            baseURL: `${Constants.apiUrl}/`,
            data: JSON.stringify(offers)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default SynchronizationService;
